/* Circuit Hero navigation reliability fix. */
(function () {
  'use strict';

  var fallbackUrls = {
    'benen-industries': '/collections/benen-industries',
    'ktuner': '/collections/ktuner',
    'engine': '/collections/engine',
    'exterior': '/collections/exterior',
    'interior': '/collections/interior',
    'suspension': '/collections/suspension',
    'accessories': '/collections/accessories-apparel',
    'sale': '/collections/sale-2'
  };

  function handleNavClick(event) {
    var anchor = event.target && event.target.closest
      ? event.target.closest('.section-header-navigation [data-navigation] > .list-menu > .menu-lv-1 > a.menu-lv-1__action')
      : null;
    if (!anchor) return;

    var href = anchor.getAttribute('href');
    var label = (anchor.querySelector('.text') || anchor).textContent.trim().toLowerCase();
    var key = label.replace(/\\s+/g, '-');
    var target = (href && href !== '#' && href !== '') ? href : fallbackUrls[key];

    if (!target) return;

    // Bypass any theme click handler that incorrectly suppresses the top-level link.
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(target);
  }

  document.addEventListener('click', handleNavClick, true);
})();
